import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  formatDateValueToISOString,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const FilterF1IssuersExclusionSchema = z.object({
  issuer_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  exception: z.string().optional(),
  created_at_from: z.any().optional().transform(formatDateValueToISOString),
  created_at_to: z.any().optional().transform(formatDateValueToISOString),
  updated_at_from: z.any().optional().transform(formatDateValueToISOString),
  updated_at_to: z.any().optional().transform(formatDateValueToISOString),
});

export type FilterF1IssuersExclusionSchema = z.infer<
  typeof FilterF1IssuersExclusionSchema
>;

export const fields: Field[] = [
  {
    name: "issuer_name_contains",
    label: `Issuer`,
    type: "asyncAutocomplete",
    base_url: "f1-quantilia/f1_issuers_exclusion",
    id_column: "issuer_id",
    column_name: "issuer_name",
    col_span: 2,
  },
  {
    name: "exception",
    label: `Exception`,
    type: "select",
    useTranslation: false,
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
  {
    name: "date",
    type: "dateRange",
    label: "Date",
    from: { name: "date_from", label: "From" },
    to: { name: "date_to", label: "To" },
    col_span: 2,
  },
  {
    name: "create",
    type: "dateRange",
    label: "Creation At",
    from: { name: "created_at_from", label: "From" },
    to: { name: "created_at_to", label: "To" },
    col_span: 2,
  },
  {
    name: "update",
    type: "dateRange",
    label: "Updated At",
    from: { name: "updated_at_from", label: "From" },
    to: { name: "updated_at_to", label: "To" },
    col_span: 2,
  },
];

export const client = "f1";

export function FilterF1IssuersExclusion() {
  return (
    <FilterTable
      client={Clients.F1}
      schema={FilterF1IssuersExclusionSchema}
      tableName={Tables.F1_ISSUERS_EXCLUSION}
      fields={fields}
      columns={2}
    />
  );
}
